// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-wechat-webview[data-v-4a4638bf] {\n  background: #fff;\n  padding: 15px 10px;\n  font-size: 16px;\n  color: #555;\n}\n.page-wechat-webview .info-header[data-v-4a4638bf] {\n  text-align: center;\n  font-weight: bold;\n  font-size: 18px;\n  padding-bottom: 15px;\n}\n.page-wechat-webview .info-content[data-v-4a4638bf] {\n  padding-bottom: 30px;\n}\n.page-wechat-webview .info-footer[data-v-4a4638bf] {\n  text-align: right;\n  line-height: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
